var map = {
	"./basketball.webp": 1660,
	"./bti-img.webp": 1661,
	"./bti-title-en.webp": 1662,
	"./cup.webp": 1663,
	"./football.webp": 1664,
	"./im-img.webp": 1665,
	"./im-title-en.webp": 1666,
	"./sb-img.webp": 1667,
	"./sb-title-cn.webp": 1668,
	"./sb-title-en.webp": 1669,
	"./sbo-img.webp": 1670,
	"./sbo-title-cn.webp": 1671,
	"./sbo-title-en.webp": 1672,
	"./sport-bg.webp": 1673,
	"./sport-ctg.webp": 1674,
	"./title-cn.webp": 1675,
	"./title-en.webp": 1676
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 788;